import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SegurosComponent } from './seguros/seguros.component';
import { VuelosComponent } from './vuelos/vuelos.component';
import { Page404Component } from './components/page404/page404.component';

export const MOTORES_ROUTES: Routes = [
  {
    path: 'seguros',
    component: SegurosComponent,
    data: { title: 'seguros views' },
    children: [
      {
        path: '',
        loadChildren: './seguros/seguros.module#SegurosModule',
      }
    ]
  },
  {
    path: 'vuelos',
    component: VuelosComponent,
    data: { title: 'vuelos views' },
    children: [
      {
        path: '',
        loadChildren: './vuelos/vuelos.module#VuelosModule',
      }
    ]
  },
  {
    path: '404',
    component: Page404Component
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forChild(MOTORES_ROUTES)],
  exports: [RouterModule]
})
export class MotoresRoutingModule { }
